import { render, staticRenderFns } from "./MobileButtonArea.vue?vue&type=template&id=58ddfb58&"
import script from "./MobileButtonArea.vue?vue&type=script&lang=ts&"
export * from "./MobileButtonArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports